import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import RatingScale from "../components/RatingScale";
import "./ScaleQuestion.scss";

const ScaleQuestion = ({
  question,
  fieldName,
  value,
  error,
  setFieldValue,
  setFieldTouched,
}) => {
  const { t } = useTranslation(["survey"]);
  const handleChange = rating => {
    setFieldValue(fieldName, rating);
    setFieldTouched(fieldName, true);
  };

  return (
    <div className="scale-question">
      <div className="scale-question__header">
        {question.question && (
          <h2 className="scale-question__title">
            {question.question}
            {question.required && (
              <span className="scale-question__required">*</span>
            )}
          </h2>
        )}

        <p className="scale-question__subtitle">
          {t("survey:wizard.scaleLabel")}
        </p>
      </div>

      <div className="scale-question__scale">
        <RatingScale
          min={1}
          max={10}
          value={value}
          onChange={handleChange}
          minLabel={question.scale_min_label || "Zdecydowanie nie"}
          maxLabel={question.scale_max_label || "Zdecydowanie tak"}
        />
      </div>

      {error && <div className="scale-question__error">{error}</div>}
    </div>
  );
};

ScaleQuestion.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    required: PropTypes.bool,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.number,
  error: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

ScaleQuestion.defaultProps = {
  value: null,
  error: null,
};

export default ScaleQuestion;
